import { MessageDetails } from 'common/models/MessageDetails';
import { BehaviorSubject } from 'rxjs';

export const loaderDetails$ = new BehaviorSubject<MessageDetails | string>(
  null
);

export function addToLoaderDetails(log: MessageDetails | string) {
  loaderDetails$.next(log);
}
